import React, { useState } from 'react';
import { Route, useParams } from 'react-router-dom';
import { Context } from "../../core/Context";

const BlankLayout = ({ children}) => {
    const { cid } = useParams();
    const [context, setContext] = useState({cid: cid, location: 0});

    return (
        <div>
            <Context.Provider value={[context, setContext]}>{children}</Context.Provider>
        </div>
    );
};

const BlankLayoutRoute = ({ component: Component, ...rest }) => {

    return (
        <Route
            {...rest}
            render={props => {
                return <BlankLayout><Component {...props} /></BlankLayout>
            }}
        />
    );
};

export default BlankLayoutRoute;